'use es6';

import { getBannerPolicyFromPrivacySetting } from 'cookie-banner/constants/privacyPolicy';
import { logError } from 'cookie-banner/utils/hspbUtils';
import { NOTIFY, OPT_IN } from 'cookie-banner/constants/privacyPolicy';
import { INITIAL_OPT_IN_COOKIE, INITIAL_OPT_IN_COOKIE_EXPIRATION, OPT_OUT_COOKIE, OPT_OUT_COOKIE_EXPIRATION, UTK_COOKIE, SESSION_COOKIE } from 'cookie-banner/constants/trackingCookies';
import BannerTemplate from 'cookie-banner/templates/BannerTemplate';
import { SCANNING_MODE_FLAG } from '../constants/hspb';
import { NOTIFY_BANNER_DISMISS_COOKIE } from '../constants/trackingCookies';
export default class OptInHandler {
  constructor(privacyBanner, privacySettings) {
    this.privacyBanner = privacyBanner;
    this.privacySettings = privacySettings;
    this.bannerTemplate = new BannerTemplate(this.privacyBanner, this.privacySettings);
  }
  showBanner() {
    const bannerPolicy = getBannerPolicyFromPrivacySetting(this.privacySettings);
    if (bannerPolicy === OPT_IN) {
      this.bannerTemplate.displayBanner();
      this.privacyBanner.sendReportingViewActivity();
    }
  }
  handle() {
    if (this.privacyBanner.context.getWindow()[SCANNING_MODE_FLAG]) {
      this.privacyBanner.setPrivacyConsent(true);
      this.privacyBanner.cookie.set(OPT_OUT_COOKIE, 'no', {
        daysToExpire: OPT_OUT_COOKIE_EXPIRATION,
        path: '/'
      });
      this.privacyBanner.cookie.set(INITIAL_OPT_IN_COOKIE, 'true', {
        daysToExpire: INITIAL_OPT_IN_COOKIE_EXPIRATION,
        path: '/'
      });
      return;
    }
    if (!this.privacySettings.active && !this.privacySettings.testing) {
      this.privacyBanner.setPrivacyConsent(true);
      return;
    }
    const context = this.privacyBanner.context;
    const cookie = this.privacyBanner.cookie;
    if (!context || !cookie) {
      return;
    }
    const bannerPolicy = getBannerPolicyFromPrivacySetting(this.privacySettings);
    if (this.privacySettings.testing) {
      if (bannerPolicy === NOTIFY) {
        this.privacyBanner.setPrivacyConsent(true);
      }
      this.bannerTemplate.render();
      return;
    }
    if (cookie.get(OPT_OUT_COOKIE) === 'yes' || !cookie.isEnabled() || !this.privacySettings.policyWording) {
      this.privacyBanner.setPrivacyConsent(false);
      return;
    }
    switch (bannerPolicy) {
      case NOTIFY:
        this.privacyBanner.setPrivacyConsent(true);
        // the user had already clicked accept on the banner
        if (cookie.get(NOTIFY_BANNER_DISMISS_COOKIE) === 'true') {
          return;
        }
        break;
      case OPT_IN:
        if (cookie.get(UTK_COOKIE) || cookie.get(SESSION_COOKIE) || cookie.get(INITIAL_OPT_IN_COOKIE) === 'true') {
          this.privacyBanner.setPrivacyConsent(true);
          return;
        }
        break;
      default:
        logError(new Error('Unsupported policy mode passed to the opt-in handler.'));
        return;
    }
    this.bannerTemplate.render();
    if (bannerPolicy !== NOTIFY) {
      this.privacyBanner.sendReportingViewActivity();
    }
  }
}